module.exports = __webpack_public_path__ + "static/media/btn_point_yleft_pre.1058acde.svg";